(function identifyModule(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  /**
   * Creates an event to identify a user when they are logged in.
   */
  function loggedInIdentify() {
    const eventForSegment = {
      event: 'User Logged In',
      eventType: 'segmentEvent',
      isLoggedInOnly: true,
      isIdentifyEvent: true,
      isIdentifyOnly: true
    };

    document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
      detail: { data: eventForSegment }
    }));
  }

  /**
   * Creates an event to identify a user when acxiom data is saved.
   * This is triggered by the 'acxiom-data-saved' event.
   * It checks if the session is new and only sends the event once per session.
   */
  function acxiomIdentify() {
    const isNewSession = sessionStorage.getItem('isNewSession');

    if (isNewSession != null) {
      return;
    }

    sessionStorage.setItem('isNewSession', 'true');

    const eventForSegment = {
      event: 'New Session',
      eventType: 'segmentEvent',
      isIdentifyEvent: true,
      isIdentifyOnly: true
    };

    document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
      detail: { data: eventForSegment }
    }));
  }

  // We need to trigger the segmentIdentify event on each page load when the user is logged in.
  global.addEventListener('load', loggedInIdentify);
  document.addEventListener('acxiom-data-saved', acxiomIdentify);
}(window));
